// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../../css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./muted.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".narrowWindow-3rLDpNZU {\n    width: 700px !important;\n}\n\n.mutedIcon-2IRL0Rzi {\n    position: absolute;\n    width: 40px;\n    height: 35px;\n    background-image: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    bottom: 62px;\n    right: 20px;\n    cursor: pointer;\n}\n", ""]);
// Exports
exports.locals = {
	"narrowWindow": "narrowWindow-3rLDpNZU",
	"mutedIcon": "mutedIcon-2IRL0Rzi"
};
module.exports = exports;
